import { Tabs, withStyles } from '@material-ui/core';

export default withStyles(theme => ({
    indicator: {
        backgroundColor: theme.palette.primary.main,
    }
}))(Tabs);